import React, { Component } from "react";
//import StarRating from  from "simple-react-star-rating";
//import { StarRatingComponent } from "react-star-rating-component";
import Rating from "@material-ui/lab/Rating";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  Tip,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
  CodeSandbox,
  Gateway,
  Codepen,
} from "grommet-icons";
import axios from "axios";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
} from "./GlobalSettings";
import LiveDemoDetail from "./LiveDemoDetail";
//import Rating from "@material-ui/lab/Rating";
import DemoListView from "./DemoListView";

class DatumContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      Demo: this.props.ddemo,
      // bShowDemoDetail: false,
      // rateVal: 1,
      showLoaderRating: false,
    };
    // this._showDemoDetail = this._showDemoDetail.bind(this);
    // this._hideDemoDetail = this._hideDemoDetail.bind(this);
    this.setRating = this.setRating.bind(this);
  }

  componentDidMount() {
    this.setState({ Demo: this.props.ddemo });
    console.log("Rating Mounted From Datum Container ", this.props.ddemo);
  }

  setRating(newRate, type, id, rating) {
    console.log("Rating Prop is ", this.props._demo);
    console.log("Rating new Values is ", newRate);
    console.log("Rating new Values Type ", type);
    console.log("Rating new Values ID ", id);
    console.log("Rating  Curent Rate is ", rating);

    // console.log("Rating content Index Val is ", this.props.indexval);

    // var tempdemoData  = this.state.Demo;
    var ActionType = "";
    if (this.props.ddemo.Content_Rating > 0) {
      ActionType = "Update";
    } else {
      ActionType = "Insert";
    }

    var RatingDataPost = {
      Rating_ID: null,
      ContentId: id,
      Rating_Value: newRate,
      Action_Type: ActionType,
      Content_Type: type,
    };

    var endpoint = "/AllContent/AddorUpdateRating";
    let token = auth.getToken();
    var postData = RatingDataPost;
    console.log("Rating Data is :", RatingDataPost);
    // this.setState({ showLoaderRating: true });
    //start below
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log(
        "Profile result Rating insert update response from API:",
        data
      );
      if (data) {
        console.log("UpdateMessage back from Rating Call response is : ");
        console.log(data);

        //this.props.hide();
        var tempdemoData = this.state.Demo;

        if (tempdemoData != undefined) {
          tempdemoData.Content_Rating = newRate;
          /*           tempdemoData.map((demoitem) => {
            if(demoitem.Content_ID == contentID){
              demoitem.Content_Rating = newRate;
            }
          }); */
          this.setState({ Demo: tempdemoData, showLoaderRating: false });
        }

        //this.setState({ Demo: tempdemoData, showLoaderRating: false });
        // auth.updateUserInfo(data);
        // this.props.hidenaa();
        // this.props.history.push("/home");
        //this.props.router.replace("/home");
      }
    });
  }

  render() {
    //var _DDemo = this.state.Demo;
    return (
      <Rating
        name={this.state.Demo.Content_ID}
        style={{ color: "green" }}
        value={this.state.Demo.Content_Rating}
        onChange={(event, newvalue) => {
          this.setRating(
            newvalue,
            this.state.Demo.Content_Type,
            this.state.Demo.Content_ID,
            this.state.Demo.Content_Rating
          );
        }}
      />
    );
  }
}
export default DatumContainer;
